function getPrettyTime(dateString: number) {
    const date = new Date(dateString);
    let ampm = 'am';
    
    let hour = date.getHours();
    if (hour > 12) {
        hour -= 12;
        ampm = 'pm';
    }
    
    const minutes: number = date.getMinutes();
    let displayMinutes: string = minutes.toString();
    if (minutes < 10) {
        displayMinutes = '0' + displayMinutes;
    }
    
    const seconds: number = date.getSeconds();
    let displaySeconds: string = seconds.toString();
    if (seconds < 10) {
        displaySeconds = '0' + displaySeconds;
    }


    return `${hour}:${displayMinutes}:${displaySeconds} ${ampm}`;
}

export { getPrettyTime };
